import { LogisticZoneType } from '~globals/types/enums';
import { toAbsoluteUrl } from '~utils/assetsHelpers';

interface LogisiticZoneOption {
  value: string;
  label: string;
  labelShort: string;
  description: string;
  icon: { src: string; alt: string };
}

export const LOGISTICS_ZONES_OPTIONS: LogisiticZoneOption[] = [
  {
    value: String(LogisticZoneType.Ranges),
    label: 'Rango de códigos postales',
    labelShort: 'Rango de códigos postales',
    description:
      // eslint-disable-next-line max-len
      'Puedes especificar uno o varios códigos postales, o definir un intervalo. Ej: 1200,1205,1500-1800.',
    icon: {
      src: toAbsoluteUrl('/icons/icon_zonetype_range.svg'),
      alt: 'Icon Zone Type Range',
    },
  },
  {
    value: String(LogisticZoneType.GeometryArea),
    label: 'Dibujar zona en mapa',
    labelShort: 'Polígono',
    description:
      // eslint-disable-next-line max-len
      'Genera un dibujo directamente sobre el mapa para que los pedidos puedan ubicarse por su geoposición.',
    icon: {
      src: toAbsoluteUrl('/icons/icon_zonetype_poly.svg'),
      alt: 'Icon Zone Type Polygon',
    },
  },
];
